import React, { useEffect, useState } from 'react';
import { SkillCategoriesWizard } from './skill-categories-wizard';
import { useAppActions, useAppState } from '../../../overmind';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { PagePath } from '../../../navigation/navigation.enums';
import { PageHeader } from '@keplerco/core';
import { useParams } from 'react-router';
import { FetchType } from '../../../enums';
import { GetSkillCategoryResponse } from '../../../overmind/actions';

export function SkillCategoriesEditPage(): React.ReactElement {
  const { skillCategorySlug } = useParams();

  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [skillCategory, setSkillCategory] = useState<GetSkillCategoryResponse>();

  useEffect(() => {
    async function getData() {
      actions.startLoader({ path: PagePath.roleSkillManagementSkillCategoriesEdit, type: FetchType.PageFetching });

      const response = await actions.readSkillCategory(skillCategorySlug!);
      setSkillCategory(response);

      actions.stopLoader(PagePath.roleSkillManagementSkillCategoriesEdit);
    }

    getData();
  }, [skillCategorySlug]);

  return (
    <PageLoaderLayer path={PagePath.roleSkillManagementSkillCategoriesEdit}>
      <div className="wrapper stack" style={{ paddingBottom: 24, gap: 24 }}>
        <PageHeader
          breadcrumbs={[
            { name: 'Roles & skills', url: `${PagePath.roleSkillManagementBase}` },
            { name: 'Manage skill categories', url: `${PagePath.roleSkillManagementBase}${PagePath.roleSkillManagementSkillCategories.replace(':companySlug', companyVariables.slug!)}` },
            { name: skillCategory?.name ?? 'Edit skill category', url: location.href },
          ]}
          title={skillCategory?.name ?? 'Edit skill category'}
          subtitle="Edit a grouping of skills to streamline role management, assessment management and analytics"
        />

        <SkillCategoriesWizard skillCategory={skillCategory} setSkillCategory={setSkillCategory} />
      </div>
    </PageLoaderLayer>
  );
}
